module.exports = __webpack_public_path__ + "img/therapy.ffc74fc0.svg";